import Constantes from '@/views/consultations/traitement-en-cours/constantes'
import AppareilaExaminer from '@/views/consultations/traitement-en-cours/examen-cliniques' 
import Analyses from '@/views/consultations/traitement-en-cours/analyses'
import Examens from '@/views/consultations/traitement-en-cours/examens'
import Ordonnances from '@/views/consultations/traitement-en-cours/ordonnances'
import Plaintes from '@/views/consultations/traitement-en-cours/plaintes'
import Evenement from '@/views/consultations/traitement-en-cours/evenement'
import CATConsigne from '@/views/consultations/traitement-en-cours/cat-consignes'

export default {
    name: 'traitement-en-cours-historique',
    components: {
        Constantes, AppareilaExaminer, Analyses, Examens,
        Ordonnances, Plaintes, Evenement, CATConsigne
    },
    props: ["consultation_id", "is_printable"],
    data() {
        return {
            j_loading: true,
            j_empty: false,

            soin_loading: false,
            soin_empty: true,

            adm_loading: true,
            adm_empty: false,

            soins_by_date_historique: [],
            s_loading: true,
            ind: 0,
            justificatif: ''
        }
    },

    computed: {
        liste_date_protocole_historique() {
            return this.$store.getters['liste_date_protocole_historique']
        },

        liste_soins_by_date_historique() {
            return this.$store.getters['liste_soins_by_date_historique']
        },

        soins_admission_historique() {
            return this.$store.getters["soins_admission_historique"]
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.listDateProtocoleSoins()
    },

    methods: {
        listDateProtocoleSoins() {
            let data = {
                consultation_id: this.consultation_id,
                est_encours: false
            }
            this.$store.dispatch("getListeDateProtocole", data).then(() => {
                if (this.liste_date_protocole_historique.length == 0) {
                    this.j_empty = true
                    this.s_loading = false
                } else {
                    this.j_empty = false

                    // let len = this.liste_date_protocole_historique.length
                    // var ind = 0
                    this.liste_date_protocole_historique.forEach((lp, jn) => {
                        this.soins_by_date_historique[jn] = {
                            date: '',
                            admission: '',
                            chambre: '',
                            soins: []
                        }
                        this.soins_by_date_historique[jn].date = lp

                        this.fetchProtocole(lp, (jn+1))
                        this.ind++
                        
                    });
                }

                this.j_loading = false
            })

            
        },

        fetchProtocole(soins_date, jn) {

            this.date_protocole = soins_date
            // this.soin_loading = true
            
            let data = {
                consultation_id: this.consultation_id,
                date: soins_date,
                jn: jn,          //  Nième jour,
                est_encours: false
            }

            this.$store.dispatch("getListeSoinsByDate", data).then(() => {
                if (this.liste_soins_by_date_historique.length > 0) {
                    this.soins_by_date_historique[jn-1].soins = this.liste_soins_by_date_historique
                    this.soin_empty = false
                    // this.jour_id = this.liste_soins_by_date_historique[0].jour_id

                    // this.est_paye = (this.liste_soins_by_date_historique[0].etat_paiement > 0)?true:false

                    this.adm_empty = false
                    this.adm_loading = true
                    this.$store.dispatch("getSoinAdmission", data).then(() => {
                        
                        if (this.soins_admission_historique.length == 0) {
                            this.adm_empty = true
                        } else {
                            this.soins_by_date_historique[jn-1].admission = this.soins_admission_historique.admission
                            this.soins_by_date_historique[jn-1].chambre = this.soins_admission_historique.chambre
                        }

                        this.adm_loading = false
                        if ((jn == this.liste_date_protocole_historique.length)) {
                            setTimeout(() => {
                                this.s_loading = false
                            }, 3000);
                        }
                    })
                } else {
                    this.soin_empty = true
                }
                // this.s_loading = false
            })
        },

        viewJustif(commentaire) {
            this.justificatif = commentaire
        },
    }
}